<figure appMapLegend class="legend-container" id="trein-legend" [attr.aria-label]="'train.legend' | translate">
  <figcaption class="legend-title">{{ 'train.legend' | translate }}</figcaption>
  <div class="legend-detailed" role="list">
    @for (signal of signalClasses; track signal.label) {
      <div class="legend-detailed-item" role="listitem" [title]="signal.range">
        <span class="legend-detailed-swatch" [style.backgroundColor]="signal.color"></span>
        <span>{{ signal.label | translate }}</span>
      </div>
    }
  </div>
</figure>
